import { Component, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ButtonForm } from "../../button-form/button-form";
import { OngetSideBar } from "../../onget-side-bar/onget-side-bar";
import { Modal } from '../../modal/modal';
import { AuthService } from '../../../core/services/auth/auth-service';

@Component({
  selector: 'app-sidebar-admin',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonForm, OngetSideBar , Modal],
  templateUrl: './sidebar-admin.html',
  styleUrl: './sidebar-admin.css',
})
export class SidebarAdmin {

  showModal = signal<boolean>(false);


  @Input() isOpen = false;
  @Output() toggleSidebar = new EventEmitter<void>();
  private router = inject(Router);
  private authService = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  mainMenu = [
    { label: 'Tableau de bord', icon: 'home', route: '/admin/dashboard' },
    { label: 'Clients', icon: 'users', route: '/admin/customers' },
    { label: 'Packs D\'abonnements', icon: 'calendar', route: '/admin/pack-abonnement' },
  ];

  adminMenu = [
    { label: 'Abonnements', icon: 'star', route: '/admin/abonnements' },
    { label: 'Séances', icon: 'star', route: '/admin/seances' },
    { label: 'Employés', icon: 'briefcase', route: '/admin/employees' },
    { label: 'Équipements', icon: 'hammer', route: '/admin/equipments' },
  ];


  toggleModal() {
    this.showModal.set(!this.showModal());
  }

  onItemClick() {
    if (this.breakpointObserver.isMatched([Breakpoints.Handset, '(max-width: 1023.98px)'])) {
      this.toggleSidebar.emit();
    }
  }

  onLogout() {
    this.authService.logout();
  }
}

